module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_17.c4e3ef68.jpg";